<div [formGroup]="splitTaskForm" class="form flex flex-col">
  {{commandTemplate?.flow?.settings?.customFlowSettings?.message}}

  <div class="flex flex-col mt-2">
    @for (protocol of protocols; track protocol.id) {
      <div class="flex flex-row items-center gap-2 px-2 py-3 bg-white border-gray border-t last:border-b">
        <p-checkbox
          formControlName="protocolIds"
          [value]="protocol.id"
          [inputId]="'split-protocol-' + protocol.id">
        </p-checkbox>
        <label class="cursor-pointer" [for]="'split-protocol-' + protocol.id">{{ protocolLabel(protocol) }}</label>
      </div>
    } @empty {
      <div class="py-3">{{ 'sharedModule.splitTaskDialogComponent.emptyState' | translate }}</div>
    }
  </div>
</div>
